import Dymo from './dymojs';
import { coupon } from './ShowTix4UCoupon';
import { receipt } from './ShowTix4UReceipt';
import { ticket } from './ShowTix4UTicket';
import { ticket550 } from './ShowTix4UTicket550';
import { ticketSet } from './ShowTix4UTicketSet';
import { flexpass } from './ShowTix4UFlexpass';

export const DymoPrint = async (printer, labelType, item, client, customer) => {
    let labelXml;
    let labelSetXml;

    switch (labelType) {
        case 'ticket':
            if (printer.name) {
                if (printer.name.includes('550')) {
                    labelXml = ticket550();
                }
                if (printer.name.includes('450')) {
                    labelXml = ticket();
                }
            } else {
                labelXml = ticket();
            }
            labelSetXml = await ticketSet(item, client, customer);
            break;
        case 'flexpass':
            labelXml = flexpass(item, client);
            break;
        case 'coupon':
            labelXml = coupon(item);
            break;
        case 'receipt':
            labelXml = receipt(item);
            break;
        default:
            labelXml = ticket(item);
    }
    
    try {
        let dymo = new Dymo();
        await dymo.print(printer, labelXml, labelSetXml);
    } catch (error) {
        try {
            let dymo = new Dymo({ hostname: '127.0.0.1' });
            await dymo.print(printer, labelXml, labelSetXml);
        } catch (error) {
            console.log(error, 'Dymo Printer', 'Failure.');
        }
    }
}


// WEBPACK FOOTER //
// ./src/lib/labels/DYMO.print.js